export function resolveClientMealSlot(now = new Date()) {
  try {
    const hourText = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Istanbul',
      hour: '2-digit',
      hour12: false
    }).format(now);
    const hour = Number(hourText || 12);
    if (hour < 11) return 'breakfast';
    if (hour < 16) return 'lunch';
    return 'dinner';
  } catch (_error) {
    return 'lunch';
  }
}

export function mealSlotLabel(mealSlot) {
  switch (String(mealSlot || '').toLowerCase()) {
    case 'breakfast':
      return 'Kahvaltı';
    case 'dinner':
      return 'Akşam';
    case 'lunch':
    default:
      return 'Öğle';
  }
}
